import { Box } from "grid-styled";
import React from "react";
import styled from "styled-components";
import { Column, Row } from "./Grid";
import { H3, SmallBody } from "./TextStyles";

const WizardCardStyle = styled(Box)`
  width: 340px;
  background-color: ${({ theme }) => theme.primary};
  color: white;
`;

const WizardImage = styled.div`
  background-image: url(${({ src }) => src});
  background-color: #f3f8f9;
  background-size: ${({ imgSize }) => imgSize || "cover"};
  background-repeat: no-repeat;
  background-position: center;
  height: ${({ imgWrapHeight }) => imgWrapHeight || "280px"};
  width: 100%;
  position: relative;
`;

export const WizardCard = ({
  image,
  imgWrapHeight = "280px",
  imgSize = "cover",
  title,
  description,
  button,
}) => {
  return (
    <Column flex="0" width={[1, 1 / 2, 1 / 3]} px="1.5rem">
      <WizardCardStyle mb="3rem">
        {image && (
          <WizardImage imgWrapHeight={imgWrapHeight} imgSize={imgSize} src={image} alt={title} />
        )}

        <Box p="1rem 2rem 2rem 2rem">
          <H3 color="white" mt="0.5rem">
            {title}
          </H3>
          <SmallBody color="white">{description}</SmallBody>
          <Box mt="1rem">{button}</Box>
        </Box>
      </WizardCardStyle>
    </Column>
  );
};

export const WizardCardContainer = ({ children }) => (
  <Row flexWrap="wrap" justifyContent="flex-start" alignItems="top" mx="-1.5rem">
    {children}
  </Row>
);
